"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonapi_1 = require("../HttpClient/jsonapi");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
class IdpAuth {
    constructor(client) {
        this._encryption = false;
        this._jsonApiClient = client._jsonApiClient;
        this._baseUrl = client.applicationUrl + "/services/idp/auth";
        this._accountUrl = client.applicationUrl + "/services/idp/auth/account";
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions && encryptionOptions.enforcement.includes("COMMON")) {
            this._encryption = true;
        }
    }
    oauthRedirect(callback, options = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("GET", this._baseUrl, {
                    params: Object.assign({ callback }, options),
                    auth: false,
                    encryption: this._encryption,
                });
                const resData = res.data.data;
                if (resData.type === "IdpOAuthLink") {
                    if (typeof window === "object" && window.location) {
                        window.location.assign(resData.attributes.url);
                        return null;
                    }
                    return (0, jsonapi_1.deserialize)(res.data, { keyForAttribute: "snake_case" });
                }
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    verifyOauth(callback, code, options = {}, intermediator) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("POST", this._baseUrl, {
                    data: Object.assign({ callback, code }, options),
                    auth: false,
                    encryption: this._encryption,
                });
                const resData = res.data.data;
                if (resData.type === "IdpAccess") {
                    let proceed = true;
                    if (typeof intermediator === "function") {
                        proceed = yield intermediator((0, lodash_clonedeep_1.default)(res.data));
                    }
                    if (proceed) {
                        this._jsonApiClient.saveTokenset({
                            rt: resData.attributes.tokenset.refresh_token,
                            at: resData.attributes.tokenset.access_token,
                            exp: resData.attributes.tokenset.expiry,
                        });
                    }
                    delete resData.attributes.tokenset;
                }
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                    extras: {
                        message: res.data.meta.message,
                    },
                });
            }
            catch (err) {
                const error = err.response
                    ? err.response.data.errors[0]
                    : err.message || err;
                return { error };
            }
        });
    }
    openAccountPage() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("GET", this._accountUrl, {
                    auth: false,
                    encryption: this._encryption,
                });
                const resData = res.data.data;
                if (resData.type === "IdpAccountLink") {
                    if (typeof window === "object" && window.open) {
                        window.open(resData.attributes.url, "_blank");
                        return null;
                    }
                    return (0, jsonapi_1.deserialize)(res.data, { keyForAttribute: "snake_case" });
                }
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
}
exports.default = IdpAuth;
